import {
  NatConfigurationState,
  NatConfigurationActionTypes,
  GET_NAT_CONFIGURATION_LIST,
  GET_NAT_CONFIGURATION_LIST_FULFILLED,
  GET_NAT_CONFIGURATION_PENDING,
  GET_NAT_CONFIGURATION_FULFILLED,
  SELECT_NAT_CONFIGURATION,
  CREATE_NAT_CONFIGURATION_PENDING,
  CREATE_NAT_CONFIGURATION_FULFILLED,
  DELETE_NAT_CONFIGURATION_FULFILLED,
  SET_NAT_CONFIGURATION_LOADING,
} from './natConfiguration.types';

export const initialState: NatConfigurationState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
};

export default function natConfigurationReducer(
  state = initialState,
  action: NatConfigurationActionTypes,
): NatConfigurationState {
  switch (action.type) {
    case GET_NAT_CONFIGURATION_LIST:
      return {
        ...state,
        selected: [],
      };

    case GET_NAT_CONFIGURATION_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
      };

    case GET_NAT_CONFIGURATION_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_NAT_CONFIGURATION_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case SELECT_NAT_CONFIGURATION:
      return {
        ...state,
        selected: action.payload || [],
      };

    case CREATE_NAT_CONFIGURATION_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case CREATE_NAT_CONFIGURATION_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case DELETE_NAT_CONFIGURATION_FULFILLED:
      return {
        ...state,
        selected: [],
      };

    case SET_NAT_CONFIGURATION_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
